import "./Equipment.module.css";
import CabecalhoInstitucional from "@/reusable_sections/Header";
import EngenhariaDeEquipamentos from "./sections/EngenhariaDeEquipamentos";
import LinhasDeProduto from "./sections/LinhasDeProduto";
import DiferenciaisConstrutivos from "./sections/DiferenciaisConstrutivos";
import InformativeFooter from "@/reusable_sections/Footer";
export default function EquipmentPage() {
  return <div>
      <CabecalhoInstitucional />
      <EngenhariaDeEquipamentos />
      <LinhasDeProduto />
      <DiferenciaisConstrutivos />
      <InformativeFooter />
    </div>;
}